import { render, staticRenderFns } from "./CloudBigData.vue?vue&type=template&id=16f66dd9&scoped=true"
import script from "./CloudBigData.vue?vue&type=script&lang=js"
export * from "./CloudBigData.vue?vue&type=script&lang=js"
import style0 from "./CloudBigData.vue?vue&type=style&index=0&id=16f66dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f66dd9",
  null
  
)

export default component.exports